import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
	root: {
		margin: theme.spacing(0, 2, 2, 2),
		padding: theme.spacing(1),
		borderRadius: theme.spacing(0.5),
		borderWidth: theme.spacing(0.25),
		position: 'relative',
	}
}));

export const SurgeonEventContainer: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ children, className, style }) => {
	const classes = useStyles();
	return (
		<Box className={classNames(classes.root, className)} style={style} data-field="surgeon-event-container">
			{children}
		</Box>
	);
};
